import { getLocalizedDateTime } from '$shared/utils/date.utils';

export function EventDateTimeCell({ timestamp }: { timestamp: string }) {
  return timestamp ? (
    <span data-testid-timestamp={timestamp}>{getLocalizedDateTime(timestamp)}</span>
  ) : null;
}
